export const appnexus_config = {

  'efe_hp_728': {
    placementId: '16504438',
    position: 1,
  },
  'efe_topics_160': {
    placementId: '16504445',
    position: 2,
  },
  'efe_topics_bottom_728': {
    placementId: '16504435',
    position: 2,
  },
  'efe_topics_mid_728_1': {
    placementId: '16504436',
    position: 2,
  },

  'efe_topics_mid_728_2': {
    placementId: '16504437',
    position: 2,
  },

  'efe_topics_mid_728_3': {
    placementId: '16504446',
    position: 2,
  },

};
